import React, { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { BsDownload } from "react-icons/bs";
import { IoIosSend } from "react-icons/io";
import { CiCalendarDate } from "react-icons/ci";
import { BiRupee } from "react-icons/bi";
import { DownloadB2BExpertInvoice } from "../../components/Modals/DownloadB2BExpertInvoice";
import NotificationService from "../../services/Notification";
import { DateTime } from "luxon";
import { FaWhatsapp } from "react-icons/fa";
import { EmailIcon } from "@chakra-ui/icons";
import { MdEmail } from "react-icons/md";
import ExpertB2BDataService from "../../services/ExpertB2B";
import { useToast } from "@chakra-ui/react";

export const WorkshopB2BExpertPriceList = ({
  total_price,
  month,
  year,
  data,
  func,
}: any) => {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { photograph_link, full_name, phone_number } = data.data;
  const [drawer, setDrawer] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(month);
  const [selectedYear, setSelectedYear] = useState(year);
  const toast = useToast();

  const handleSendWhatsappNotification = () => {
    let dateTime = DateTime.now().setZone("Asia/Kolkata");
    const data = {
      template_name: "monthly_b2b_expert_invoice",
      lead_phone_numbers: [`+91${phone_number.slice(-10)}`],
      notification_status: "PENDING",
      variable_values: [full_name],
      error: [],
      source: "SERVICE",
      schedule_date: dateTime.toFormat("MM/dd/yyyy"),
      schedule_time: dateTime.toFormat("h:mm a"),
      booking_id: "",
    };
    NotificationService.scheduleWhatsappNotification(data);
  };

  const handleSendEmailNotification = () => {
    ExpertB2BDataService.sendB2BExpertInvoiceEmail(
      data._id,
      month,
      year
    );
  };

  const handleDownloadB2BExpertInvoice = async () => {
    try {
      const response = await ExpertB2BDataService.downloadB2BExpertInvoice(
        data._id,
        month,
        year
      );
      // const url = window.URL.createObjectURL(new Blob([response.data]));
      const url = response.data.downloadURL;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${full_name}-${month}-${year}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      // handleClose();
    } catch (error) {
      toast({
        position: "top",
        title: "Billing Summary Download Failed",
        description:
          "There was an error downloading the billing summary. Please try again later.",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
    }
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div className="col-md-12 expert-pricing-lower-div mb-2 ml-2">
      <div className="our-team expert_div">
        <div className="pic">
          <img
            src={photograph_link ? photograph_link : "/img/avtar.png"}
            alt=""
          />
        </div>
        <div className="team-content">
          <h3 className="title">{full_name}</h3>
          <div className="post d-flex align-items-center justify-content-center gap-2">
            <span>
              <CiCalendarDate className="mr-1" />
            </span>
            <div>
              {monthNames[month - 1]} {year}
            </div>
          </div>
          <div className="post d-flex align-items-center justify-content-center gap-2">
            <span>
              <BiRupee className="mr-1" />
            </span>
            <div>{total_price}</div>
          </div>
        </div>
        <ul className="social">
          <li>
            <a>
              <BsDownload onClick={handleDownloadB2BExpertInvoice} />
            </a>
          </li>
          <li>
            <a>
              <FaWhatsapp onClick={handleSendWhatsappNotification} />
            </a>
          </li>
          <li>
            <a>
              <MdEmail onClick={handleSendEmailNotification} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
